import React from 'react';

const diensten = [
  { icon: 'icon-buildings', title: 'Balkonrenovatie', text: 'Volledig herstel van versleten en lekkende balkons, incl. waterdichting en aansluitingen.', anim: 'fadeInRight', delay: 200 },
  { icon: 'icon-wall', title: 'Galerijvloeren', text: 'Naadloze, duurzame vloersystemen voor galerijen en gemeenschappelijke buitenruimten.', anim: 'fadeInLeft', delay: 300 },
  { icon: 'icon-crane-1', title: 'Betonreparatie', text: 'Vakkundig herstel van betonrot, scheuren en aangetaste wapening — esthetisch én constructief.', anim: 'fadeInUp', delay: 400 },
  { icon: 'icon-paint-roller', title: 'Vloercoatings', text: 'Strakke afwerking voor technische ruimten, bergingen en gemeenschappelijke vloeren.', anim: 'fadeInRight', delay: 500 },
  { icon: 'icon-stairs', title: 'Antislip & slijtlagen', text: 'Veilige loopvlakken op trappen, hellingen en galerijen.', anim: 'fadeInUp', delay: 600 },
  { icon: 'icon-hook', title: 'Afdichtingen', text: 'Waterdichte afwerking van afvoeren, doorvoeren, schoorstenen en kozijnaansluitingen.', anim: 'fadeInLeft', delay: 700 },
];

const ServiceTwo = () => {
  return (
    <section className="service-two" id="diensten">
      <div className="container">
        <div className="row">
          <div className="col-xl-8 col-lg-8 wow fadeInLeft" data-wow-delay="100ms">
            <div className="service-two__left">
              <div className="section-title text-left">
                <div className="section-title__tagline-box">
                  <span className="section-title__tagline">Onze diensten</span>
                </div>
                <h2 className="section-title__title">
                  Wat wij voor <span>u</span>
                  <br /> doen
                </h2>
              </div>
              <p className="service-two__text">
                Balkons, galerijen en betonherstel voor particulieren, VvE's en bedrijven —
                <br /> uitgevoerd door dezelfde vakman die de offerte maakt. Vaste opleverdatum.
              </p>
              <div className="service-two__view-all">
                <a href="#contact">Vraag een opname aan<span className="icon-dubble-arrow-right"></span></a>
              </div>
            </div>
          </div>

          {diensten.map((dienst, index) => (
            <div className={`col-xl-4 col-lg-4 wow ${dienst.anim}`} data-wow-delay={`${dienst.delay}ms`} key={index}>
              <div className="service-two__single">
                <div className="service-two__icon-and-title">
                  <div className="service-two__icon">
                    <span className={dienst.icon}></span>
                  </div>
                  <div className="service-two__title">
                    <a href="#contact">{dienst.title}</a>
                  </div>
                </div>
                <p className="service-two__single-text">{dienst.text}</p>
                <div className="service-two__read-more">
                  <a href="#contact" aria-label={`Meer info over ${dienst.title}`}>Meer info<span className="icon-dubble-arrow-right"></span></a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceTwo;
